export default __webpack_public_path__ + "static/media/AdBeasts_02.44f62f13.png";